// @react/hooks/useTaskTaskCategory.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { taskTaskCategoryStore } from '@core/stores';

/**
 * React hook for TaskCategory operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useTaskTaskCategory } from '@react/hooks';
 *
 * const TaskCategoryList = observer(() => {
 *   const store = useTaskTaskCategory();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useTaskTaskCategory() {
  return taskTaskCategoryStore;
}
